import React, { createContext, useContext, useState } from 'react';

const EmailContext = createContext();

export const EmailProvider = ({ children }) => {
    const [emailState, setEmailState] = useState({
        tempEmail: null,
        createdAt: null,
        validTill: null,
        remainingTimeInSeconds: null,
        loading: true,
        error: null,
    });

    return (
        <EmailContext.Provider value={[emailState, setEmailState]}>
            {children}
        </EmailContext.Provider>
    );
};

export const useEmailContext = () => {
    const context = useContext(EmailContext);
    if (!context) {
        throw new Error('useEmailContext must be used within an EmailProvider');
    }
    return context;
}; 